import { getAllOperations, Operation as OperationType } from "../../operations/services/operationService";

// 操作接口 - 与原始OperationType兼容
export interface Operation {
  id: string;
  name: string;
  displayName?: string;
  code: string;
  description?: string;
  is_active: boolean;
  is_system: boolean;
  created_at: string;
  updated_at: string;
  service_name?: string;
  serviceName?: string;
  module?: string;
  action?: string;
  page?: string;
}

/**
 * 权限服务类
 * 处理所有权限相关的数据获取和操作
 */
export class PermissionService {
  /**
   * 获取服务的权限操作列表
   */
  static async fetchServicePermissions(serviceName: string): Promise<Operation[]> {
    try {
      // 调试信息已移除
      const allOperations = await getAllOperations();
      // 调试信息已移除

      // 过滤出属于当前服务的操作
      const normalizedServiceName = (serviceName || "").toLowerCase();
      const serviceOperations = allOperations.filter((operation) => {
        const operationService =
          operation.service || operation.service_name || (operation.code ? operation.code.split(":")[0] : "");
        return (
          operationService &&
          operationService.toString().toLowerCase() === normalizedServiceName
        );
      });

      console.log(
        `[PermissionService] ${serviceName} 匹配到 ${serviceOperations.length} 个操作`,
        serviceOperations.map((op) => op.code)
      );
      // 调试信息已移除

      return serviceOperations as unknown as Operation[];
    } catch (error) {
      console.error("获取服务权限操作失败:", error);
      throw new Error("获取服务权限操作失败");
    }
  }

  /**
   * 获取所有操作列表
   */
  static async getAllOperations(): Promise<Operation[]> {
    try {
      return await getAllOperations() as unknown as Operation[];
    } catch (error) {
      console.error("获取所有操作失败:", error);
      throw new Error("获取所有操作失败");
    }
  }
}
